<template>
    <div class="scrollableArea">
        <!-- <navigator :reservation="reservation" :selectedAgentComissions="selectedAgentComissions" v-on:agentComissionsChanged="agentComissionsChanged"></navigator> -->
        <div class="container-fluid">

            <div class="row">

                <div class="col-sm-8 d-flex px-0 text-center bg-darker dark font-weight-600">
                    <div class="col-sm-4 px-0 py-3 text-uppercase pointer" :class="{'selectedTab':tab.selected, 'centerTab':tab.centerTab, 'opacity-50': !tab.enabled()}" @click="changeTab(tab)" v-for="tab in tabs2">{{tab.label}}</div>
                </div>

                <div class="col-sm-4">
                    <div class="row h-100">
                        <div class="col-sm-12 px-0 py-3 text-center bg-darkest lightest font-weight-600">Summary</div>
                    </div>
                </div>

            </div>

        </div>
        <div class="container-fluid scrollThis">
            <div class="row h-100">

                <div class="col-sm-8 bg-lighter">
                    <!-- <resume-details></resume-details> -->
                    <div :is="visibleArea" :reservation="reservation"></div>
                </div>

                <div class="col-sm-4">
                    <reservation-summary :reservation="reservation" :selectedAgentComissions="selectedAgentComissions"></reservation-summary>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import navigator from './Resume/Navigator'
import ResumeDetails from './Resume/Details'
import ResumeAddTransport from './Resume/AddTransport'
import ResumeAddExtra from './Resume/AddExtra'
import ReservationSummary from './Resume/ReservationSummary'
import { reservationsMixin } from '@/mixins/reservations'

export default {
    mixins: [reservationsMixin],
    data: function() {
        return {
            reservation: null,
            tabs: [ //old
                {
                    label: 'Details',
                    component: 'resume-details',
                    selected: true,
                    enabled: true
                },
                {
                    label: 'Add Transport',
                    component: 'resume-add-transport',
                    centerTab: true,
                    selected: false,
                    enabled: false
                },
                {
                    label: 'Add Extra',
                    component: 'resume-add-extra',
                    selected: false,
                    enabled: false
                }
            ],
            tabs2:  [
                {
                    label: 'Details',
                    component: 'resume-details',
                    selected: true,
                    enabled: function () {
                        return true
                    }
                },
                {
                    label: 'Add Transport',
                    component: 'resume-add-transport',
                    centerTab: true,
                    selected: false,
                    enabled: this.enableTransports
                    // enabled: this.loggedUserAccessList.channel? this.loggedUserAccessList.channel.isAllowedSellTransports : false
                },
                {
                    label: 'Add Extra',
                    component: 'resume-add-extra',
                    selected: false,
                    enabled: this.enableComponents
                    // enabled: this.loggedUserAccessList.channel? this.loggedUserAccessList.channel.isAllowedSellComponents : false
                }
            ],
            selectedAgentComissions: null,
            visibleArea: 'resume-details'

        }
    },
    created: function() {
        this.resetReservation();

        // Set reservation
        this.reservation = this.getReservation

        //get reservation id
        this.getReservationSequencialNumber()


        // this adds "bookingComponents" to resetReservation root
        if(this.reservation.event.eventComponents){
            this.reservation.bookingComponents = JSON.parse(JSON.stringify(this.reservation.event.eventComponents))

            this.reservation.bookingComponents.map(bookingComponent => {
                bookingComponent.originalQuantity = bookingComponent.quantity
                bookingComponent.quantity = 0
            })
        }

        if(this.reservation.event.eventGenderPrices){
            this.reservation.bookingGenderPrices = JSON.parse(JSON.stringify(this.reservation.event.eventGenderPrices))
            for(let genderPrice of this.reservation.bookingGenderPrices){
                if(genderPrice.genderPriceType == 1 && genderPrice.isExcludedFromBilling == false){
                    // this.$set(genderPrice, 'quantityToBook', 1)
                    genderPrice.quantityToBook = 1
                } else {
                    genderPrice.quantityToBook = 0
                    //this.$set(genderPrice, 'quantityToBook', 0)
                }
            }
        }


        //if there is no product selected (ex.: if F5 is pressed)
        // send to new reservation
        if(!this.reservation.product.id){
            this.$router.push({ name: 'pluralo.reservation' });
            return false //exits "Created" hook
        }



        if(this.$route.params.id){
            alert(this.$route.params.id)
        }

        //gets calcultions for this reservations with 0 totals
        this.setReservationCalculations(this.reservation);

        //check if the event has mandatory extras and show them as a popup
        this.showMandatoryExtras(this.reservation)

        // cleans calculationsGUID as this is a new reservation
        this.resetCalculationsGuid()

        // add billing list item 0 to use the billing details
        this.$set(this.reservation, 'billingList', [
            {
                details: {
                    address: null,
                    businessName: null,
                    city: null,
                    country: null,
                    vat: null
                }
            }
        ])

        //set default resource
        this.setResource()

        // download Selected product commissions
        this.downloadSelectedProductCommissions(this.reservation.event.product.id)

    },
    computed: {
        ...mapGetters([
            'getReservation',
            'getSelectedProductCommissions',
            'account',
            'getIsGettingReservationNr'
        ]),
        // reservation: function() {
        //     return this.getReservation;
        // },
    },
    methods:{
        ...mapActions([
            'resetReservation',
            'setReservationCalculations',
            'resetCalculationsGuid',
            'downloadSelectedProductCommissions',
            'getNumberForNewReservation'
        ]),
        enableTransports: function () {
            return this.loggedUserAccessList.channel? this.loggedUserAccessList.channel.isAllowedSellTransports : false
        },
        enableComponents: function () {
            return this.loggedUserAccessList.channel? this.loggedUserAccessList.channel.isAllowedSellComponents : false
        },
        changeTab: function(tab) {
            if(!tab.enabled()){
                this.$toasted.error('Access restricted');
                return false
            }

            //deselect all tabs
            for(let iTab of this.tabs2){
                iTab.selected = false;
            }

            this.visibleArea = tab.component;
            tab.selected = true;
        },
        agentComissionsChanged: function(data){
            this.selectedAgentComissions = data;
        },
        setResource: function (){
            this.$set(this.reservation, 'selectedResource', this.resourcesWithAvailability[0])
            // this.$set(this.reservation, 'selectedResource', this.reservation.event.eventResources[0])
        },
        getReservationSequencialNumber: function () {
            this.getNumberForNewReservation().then(response => {
                if(response.status == 200){
                    this.$set(this.reservation, 'sequencialNumber', response.data)
                    // this.reservation.id = response.data
                }
            })
        }
    },
    components: {
        navigator,
        ResumeDetails,
        ResumeAddTransport,
        ResumeAddExtra,
        ReservationSummary,
    }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_variables.scss";

.scrollableArea{
    display: flex;
    height: 94vh;
    flex-direction: column;

    .scrollThis{
        overflow: auto;
        height: 100%;
    }
}

.selectedTab{
    color: $lightest;
    border-bottom: 4px solid $color-6;
}

.centerTab{
    border-left: 2px solid $darkest;
    border-right: 2px solid $darkest;
}
</style>



// WEBPACK FOOTER //
// Resume.vue?2821eb30